import { ContentLoader, Box } from "@bca/ui-library";
import React from "react";

const FiltersDesktopLoader = () => {
  return (
    <>
      {Array.from(Array(6).keys()).map((index) => (
        <Box key={index} width={211} height={67}>
          <ContentLoader width="100%" height="100%" title="Loading avatar...">
            <rect width={19} height={19} rx={4} ry={4}></rect>
            <rect width={134} height={19} x={24} rx={4} ry={4}></rect>
          </ContentLoader>
        </Box>
      ))}
    </>
  );
};

export default FiltersDesktopLoader;
